import { render, staticRenderFns } from "./sizeTable.vue?vue&type=template&id=2109f332&scoped=true&"
import script from "./sizeTable.vue?vue&type=script&lang=js&"
export * from "./sizeTable.vue?vue&type=script&lang=js&"
import style0 from "./sizeTable.vue?vue&type=style&index=0&id=2109f332&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109f332",
  null
  
)

export default component.exports